// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__48TT3","signatureBlock":"Footer_signatureBlock__3xlSq","signature":"Footer_signature__18CoL"};